import { useSelector } from 'react-redux';

import type { RootState } from '@/Infrastructure/State';

export const selectBuyNowShippingGrouping = (state: RootState) =>
  state.buyNow.shippingGrouping;
export const selectBuyNowShippingGroupingData = (state: RootState) =>
  state.buyNow.shippingGrouping.data;
export const selectBuyNowShippingGroupingLoading = (state: RootState) =>
  state.buyNow.shippingGrouping.isLoading;
export const selectBuyNowShippingGroupingError = (state: RootState) =>
  state.buyNow.shippingGrouping.error;
export const selectBuyNowShippingGroupingStatusCode = (state: RootState) =>
  state.buyNow.shippingGrouping.statusCode;
export const selectBuyNowShippingGroupingRetryCount = (state: RootState) =>
  state.buyNow.shippingGrouping.retryCount;

const useBuyNowShippingGrouping = () => {
  const response = useSelector(selectBuyNowShippingGrouping);
  return response;
};

export default useBuyNowShippingGrouping;
